
export async function pingDevice (assetId) {
  try {
    const response = await fetch(`/api/v1/assets/${assetId}/ping`, { method: 'PUT' })
    return await response.json()
  } catch (error) {
    return { success: false, message: error.message }
  }
}
